import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des langues
 */
const languagesConfig = {
  entityName: 'languages',
  apiEndpoint: '/api/config/tool/languages',
  exportFileName: 'languages',
  
  translations: {
    title: 'LANGUAGES_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { key: 'language_key', label: 'Code', labelKey: 'TABLE_CODE' },
    { key: 'language_name', label: 'Nom', labelKey: 'TABLE_NAME' },
    { 
      key: 'is_available', 
      label: 'Activé', 
      labelKey: 'TABLE_ENABLED',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'language_key',
      label: 'Code de la langue',
      labelKey: 'FORM_LANGUAGE_CODE',
      type: 'text',
      required: true,
      placeholder: 'fr, en, es, de...'
    },
    {
      name: 'language_name',
      label: 'Nom de la langue',
      labelKey: 'FORM_LANGUAGE_NAME',
      type: 'text',
      required: true,
      placeholder: 'Français, English, Español...'
    },
    {
      name: 'is_available',
      label: 'Actif',
      labelKey: 'FORM_IS_ENABLED',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'is_available',
      label: 'Statut',
      labelKey: 'FILTER_IS_AVAILABLE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    language_key: '',
    language_name: '',
    is_available: true
  }
};

/**
 * Composant d'administration des langues
 */
export default function AdminLanguagesTab() {
  return (
    <AdminDataTable {...languagesConfig} />
  );
}
